import React, { useEffect, useState } from "react";

export const finalDate = new Date(2025, 10, 23, 17, 0, 0);

export default function CountDownTimer() {
  const [countdown, setCountdown] = useState("");
  const [isCountDownFinished, setIsCountDownFinished] = useState(false);

  useEffect(() => {
    const calculateCountdown = () => {
      const now = new Date();

      let targetDate = finalDate;

      const difference = targetDate - now;

      if (difference <= 0) {
        setCountdown("00:00:00");
        setIsCountDownFinished(true);
        return;
      }

      const days = Math.floor(difference / (1000 * 60 * 60 * 24));
      const hours = Math.floor(
        (difference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
      );
      const minutes = Math.floor((difference % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((difference % (1000 * 60)) / 1000);

      // Format with days if more than 0 days remaining
      if (days > 0) {
        setCountdown(
          `${days}d ${String(hours).padStart(2, "0")}:${String(
            minutes
          ).padStart(2, "0")}:${String(seconds).padStart(2, "0")}`
        );
      } else {
        setCountdown(
          `${String(hours).padStart(2, "0")}:${String(minutes).padStart(
            2,
            "0"
          )}:${String(seconds).padStart(2, "0")}`
        );
      }
    };

    calculateCountdown();
    const interval = setInterval(calculateCountdown, 1000);

    return () => clearInterval(interval);
  }, []);

  if (isCountDownFinished) {
    return null;
  }

  return (
    <div className="text-black">
      ⏳ Switching to <span className="font-bold text-[#5E45FF]">Razeen+</span>{" "}
      in <span className="font-bold">{countdown}</span>
    </div>
  );
}
